import React from 'react';
import { Props } from './types';
import { Select, Tooltip } from 'antd';
import { SmileOutlined, FrownOutlined } from '@ant-design/icons';
import Justification from '../../Modal/Justification';
import { IModification } from '../../Modal/Justification/types';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import api from '../../../../service/api';
import { SKW_PREFIX } from '../../../../utils/constants';
import { openNotification } from '../../Utils';
import { loadRequest } from '../../../../store/ducks/ocorrencia/actions';

const Severidade: React.FC<Props> = ({ currentSeverity }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState<boolean>(false);
  const [modification, setModification] = React.useState<IModification>();
  const { Option } = Select;
  const perfil = useSelector((state: ApplicationState) => state.auth?.user?.perfil);
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const handlePerfil = perfil && ['A', 'ANCD'].includes(perfil);
  const ocorrencia = useSelector((state: ApplicationState) => state.Ocorrencia?.data['ocorrencia']);

  const handleChang = (e: string): void => {
    if (perfil === 'A' || perfil === 'ANCD') {
      setModification({ urgencia: e });
      setOpen(true);
    } else {
      api
        .post(`call?serviceName=${SKW_PREFIX}atualizaOcorrencia&token=${token}`, {
          protocolo: ocorrencia?.protocolo,
          urgencia: e,
        })
        .then(() => {
          openNotification('Ok!', <SmileOutlined />, 'Alteração efetuada com sucesso!');
        })
        .catch(() => {
          openNotification('Ops!', <FrownOutlined />, 'Não foi possível efetuar essa alteração!');
        })
        .finally(() => {
          setTimeout(() => {
            dispatch(loadRequest(ocorrencia?.protocolo));
          }, 200);
        });
    }
  };

  return (
    <>
      <Justification open={open} setOpen={setOpen} modification={modification} />
      <Tooltip
        title={
          ocorrencia?.status !== 'AC'
            ? ''
            : 'Não é possível alterar a severidade de um atendimento finalizado'
        }
      >
        <Select
          data-cy="selectSeverity"
          defaultValue={currentSeverity}
          onChange={handleChang}
          style={{ width: '100%' }}
          disabled={ocorrencia?.status === 'AC'}
        >
          <Option value="URGENTE">Urgente</Option>
          <Option value="ALTA" disabled={handlePerfil && currentSeverity === 'URGENTE'}>
            Alta
          </Option>
          <Option
            value="MEDIA"
            disabled={
              (handlePerfil && currentSeverity === 'ALTA') ||
              (handlePerfil && currentSeverity === 'URGENTE')
            }
          >
            Média
          </Option>
          <Option value="BAIXA" disabled={handlePerfil && currentSeverity !== 'BAIXA'}>
            Baixa
          </Option>
        </Select>
      </Tooltip>
    </>
  );
};

export default Severidade;
